import { useState, useEffect } from 'react';
import { Preferences } from '@capacitor/preferences';

function useCapacitorStorage(defaultValue, key) {
  const [value, setValue] = useState(defaultValue);
  const [isHydrated, setIsHydrated] = useState(false);

  // NOTE: useEffect will run once to load the initial value from Storage
  useEffect(() => {
    setIsHydrated(false);
    async function loadStoredValue() {
      await Preferences.migrate();
      const { value: storedValue } = await Preferences.get({ key });
      if (storedValue) {
        try {
          setValue(JSON.parse(storedValue));
        } catch (e) {
          console.error(`Error parsing stored value for key '${key}'`, e);
          setValue(defaultValue);
        }
      }
      setIsHydrated(true);
    }
    loadStoredValue();
  }, [key]);

  // NOTE: useEffect will run every time the value changes to save it to Storage
  useEffect(() => {
    if (!isHydrated) return;
    Preferences.set({
      key: key,
      value: JSON.stringify(value),
    });
  }, [isHydrated, key, value]);

  return [value, setValue];
}

export default useCapacitorStorage;
